import React, { useState } from 'react';
import { Button, Form, Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useAppDispatch } from 'app/store';

type TProps = {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  id: string | undefined;
  setIsBtnGroupVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmit?: (text: string) => void;
  loading?: boolean;
};

export const VacationModal = ({ openModal, setOpenModal, id, setIsBtnGroupVisible, handleSubmit, loading }: TProps) => {
  const [modalText, setModalText] = useState<string>();
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const handleOk = () => {
    if (handleSubmit) {
      handleSubmit(modalText ?? '');
      setOpenModal(false);
      return;
    }
    if (modalText && modalText?.length > 0 && modalText !== '') {
      setOpenModal(false);
      if (setIsBtnGroupVisible) setIsBtnGroupVisible(false);
    }
  };

  const handleCancel = () => {
    setOpenModal(false);
    setModalText('');
  };

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // если отсутствует текст, игнорирую пробелы и переносы строки клавищей "ENTER"
    if (!modalText) {
      setModalText(e.target.value.replace(/^\s+/g, ''));
    } else {
      setModalText(e.target.value);
    }
  };

  return (
    <Modal
      title="Напишите причину отказа"
      visible={openModal}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Отмена
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} disabled={!modalText} loading={loading}>
          Отправить
        </Button>,
      ]}
    >
      <Form name="rejectionForm" form={form}>
        <Form.Item rules={[{ required: true, message: 'Пожалуйста, введите текст' }]}>
          <TextArea
            required
            name="rejectionReason"
            placeholder="Причина отказа"
            rows={8}
            maxLength={300}
            minLength={1}
            showCount
            value={modalText}
            onChange={onChange}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
